import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, SendInviteModel, UserRoleType } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useLenderInviteModelQuery(
	guid: Guid | undefined,
	lenderGuid: Guid | null | undefined,
	roleType: UserRoleType | null | undefined,
	options?: Omit<UseQueryOptions<SendInviteModel, unknown, SendInviteModel, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();
	return useQuery(
		QueryKeys.DataRoomUsers.Invite(guid, lenderGuid),
		() => AxiosUtils.getResponseData<SendInviteModel>(api.get(getInviteModeApiUrl(roleType, guid, lenderGuid))),
		options
	);
}

function getInviteModeApiUrl(
	roleType: UserRoleType | null | undefined,
	guid: Guid | undefined,
	lenderGuid: Guid | null | undefined
): string {
	if (roleType == 'BankUser' || roleType == 'DataRoomUser') {
		return CerebroApiEndpoints.DataRoomUsers.Invite(guid, lenderGuid);
	}

	return CerebroApiEndpoints.TeamMembers.Invite(guid, lenderGuid);
}
